import { AiChatMessage } from '../ai-chat/aiChatTypes';
import { ChatCompletionRequestMessageRole } from '@server/ai';

export const createMockArtifactMessage = (): AiChatMessage => {
  return {
    role: ChatCompletionRequestMessageRole.ASSISTANT,
    content: "I've created an analysis for your opportunity object fields.",
    contentType: 'artifact',
    artifactData: {
      artifactId: 'mock-artifact-123',
      title: 'Opportunity Object Field Cleanup Analysis',
      subtitle: 'Interactive artifact • Version 1',
    },
    createdAt: new Date().toISOString(),
    isError: false,
  };
};

export const createMockLicenseArtifactMessage = (): AiChatMessage => {
  return {
    role: ChatCompletionRequestMessageRole.ASSISTANT,
    content: "I've created a comprehensive license utilization analysis for your organization.",
    contentType: 'artifact',
    artifactData: {
      artifactId: 'license-artifact-demo-001',
      title: 'License Utilization Analysis',
      subtitle: 'Interactive dashboard • TechVentures Global • October 2025',
    },
    createdAt: new Date().toISOString(),
    isError: false,
  };
};

export const createMockAgentforceArtifactMessage = (): AiChatMessage => {
  return {
    role: ChatCompletionRequestMessageRole.ASSISTANT,
    content: "I've created a comprehensive Agentforce analysis dashboard for your organization.",
    contentType: 'artifact',
    artifactData: {
      artifactId: 'agentforce-artifact-demo-001',
      title: 'Agentforce Analysis Dashboard',
      subtitle: 'Interactive dashboard • AI Agent Performance • October 2025',
    },
    createdAt: new Date().toISOString(),
    isError: false,
  };
};

export const createMockIntegrationArtifactMessage = (): AiChatMessage => {
  return {
    role: ChatCompletionRequestMessageRole.ASSISTANT,
    content: "I've created a comprehensive integration analysis dashboard for your systems.",
    contentType: 'artifact',
    artifactData: {
      artifactId: 'integration-artifact-demo-001',
      title: 'Integration Analysis Dashboard',
      subtitle: 'Interactive dashboard • System Integrations • October 2025',
    },
    createdAt: new Date().toISOString(),
    isError: false,
  };
};

export const createMockTechDebtArtifactMessage = (): AiChatMessage => {
  return {
    role: ChatCompletionRequestMessageRole.ASSISTANT,
    content: "I've created a comprehensive technical debt analysis for your codebase.",
    contentType: 'artifact',
    artifactData: {
      artifactId: 'techdebt-artifact-demo-001',
      title: 'Technical Debt Analysis',
      subtitle: 'Interactive dashboard • Code Quality & Debt • October 2025',
    },
    createdAt: new Date().toISOString(),
    isError: false,
  };
};

export const createMockUserMessage = (): AiChatMessage => {
  return {
    role: ChatCompletionRequestMessageRole.USER,
    content:
      'Can you create an assessment on field cleanup for the opportunity object? Include unused, duplicate, and newly added fields.',
    createdAt: new Date().toISOString(),
  };
};
